/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the ComponentType
 * @export
 */
export const ComponentTypeStatus = {
    Confirmed: 'CONFIRMED',
    Pending: 'PENDING'
} as const;
export type ComponentTypeStatus = typeof ComponentTypeStatus[keyof typeof ComponentTypeStatus];


export function instanceOfComponentTypeStatus(value: any): boolean {
    for (const key in ComponentTypeStatus) {
        if (Object.prototype.hasOwnProperty.call(ComponentTypeStatus, key)) {
            if (ComponentTypeStatus[key as keyof typeof ComponentTypeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComponentTypeStatusFromJSON(json: any): ComponentTypeStatus {
    return ComponentTypeStatusFromJSONTyped(json, false);
}

export function ComponentTypeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentTypeStatus {
    return json as ComponentTypeStatus;
}

export function ComponentTypeStatusToJSON(value?: ComponentTypeStatus | null): any {
    return value as any;
}

export function ComponentTypeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ComponentTypeStatus {
    return value as ComponentTypeStatus;
}

